import styles from "@store/Components/Store/StoreProductDetailsView/styles";
import { css } from "styled-components";

Object.assign(styles, {
    headingNumbersGridHeader: {
        ...styles.headingNumbersGridHeader,
        width: [0, 0, 0, 4, 4],
    },
    detailQtyInnerWrapperGridHeader: {
        ...styles.detailQtyInnerWrapper,
        css: css`
            ${styles.detailQtyInnerWrapper?.css ?? ""}
            align-items: center;
        `,
        width: [7, 6, 6, 3, 3],
    }
});